import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import "./styles.styl";

export default function CollapsiblePanel({
  title,
  children,
  defaultOpen = false,
  onToggle,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(
    defaultOpen ? "auto" : "0px",
  );
  const [isAnimating, setIsAnimating] = useState(false);
  const [showPreloader, setShowPreloader] = useState(false);

  useEffect(() => {
    if (defaultOpen && onToggle) {
      onToggle(true);
    }
  }, []);

  const handleToggle = (e) => {
    e.preventDefault();

    if (isAnimating) return;
    setIsAnimating(true);

    const nextOpenState = !isOpen;
    if (nextOpenState) {
      setShowPreloader(true);

      if (onToggle) {
        onToggle(true);
      }

      setIsOpen(true);

      setTimeout(() => {
        if (contentRef.current) {
          const height = contentRef.current.scrollHeight;
          setContentHeight(`${height}px`);
        }

        setTimeout(() => {
          setShowPreloader(false);
          setIsAnimating(false);
          setContentHeight("auto");
        }, 200);
      }, 50);
    } else {
      setIsOpen(false);
      setContentHeight("0px");

      if (onToggle) {
        onToggle(false);
      }

      setTimeout(() => {
        setIsAnimating(false);
      }, 300);
    }
  };

  return (
    <div className="collapsible-panel">
      <div
        className={classNames("collapsible-panel__header", {
          "is-open": isOpen,
        })}
        onClick={handleToggle}
        onMouseDown={(e) => e.preventDefault()}
        role="button"
        aria-expanded={isOpen}
        tabIndex={0}
      >
        <div className="collapsible-panel__title">{title}</div>
        <div
          className={classNames("collapsible-panel__icon", {
            "is-open": isOpen,
          })}
        >
          {showPreloader && (
            <div className="collapsible-panel__preloader"></div>
          )}
        </div>
      </div>
      <div
        className={classNames("collapsible-panel__content", {
          "is-open": isOpen,
        })}
        style={{ height: contentHeight }}
      >
        <div ref={contentRef}>{isOpen && children}</div>
      </div>
    </div>
  );
}
